module.exports = __webpack_public_path__ + "img/foot_wechat.40279cf4.png";